export function getCurrentCentralEuropeDate() {
    return new Date(new Date().getTime() + new Date().getTimezoneOffset() * 60000)
}